module.exports = __webpack_public_path__ + "img/UMC-logo.885ca05f.svg";